import React from 'react';
import styles from './Characteristics.module.css';
import CharacteristicsSwiper from "./CharacteristicsSwiper";

const Characteristics = ({openModal}) => {
    return (
        <div className={styles.container}>
            <h1> <span style={{color: 'red'}}>Характеристики</span> комплекту</h1>
            <CharacteristicsSwiper openModal={openModal} />

        </div>
    );
};

export default Characteristics;